.wrapper {
	display: flex;
	flex-direction: column;
	gap: 4px;
	/* Prevent content shift when errorMessage appears */
	min-height: 78px;
}

.invalidField .input {
	border: solid 1px var(--border-error);
	color: var(--content-error);
}

.invalidField .input::placeholder {
	color: var(--content-error);
}

.label {
	/* Disable old layout forced style */
	margin-bottom: unset !important;
}

.input {
	composes: body-2 from global;
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	color: var(--content-primary);
	border-radius: 8px;
	width: 100%;
	padding: 8px 12px;
	text-align: left;
}

.input::placeholder {
	color: var(--content-tertiary);
}

.trigger {
	display: flex;
	align-items: center;
	gap: 8px;
}

.triggerValue {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.invalidField .input:hover:not(:focus-visible) {
	border: solid 1px var(--border-error);
}

.input:hover:not(:focus-visible) {
	border: solid 1px var(--border-hover);
}

.input:focus-visible {
	outline: var(--focus-outline);
}

.input[data-disabled],
.input:disabled {
	opacity: 0.5;
	cursor: not-allowed;
	background-color: var(--elevation-low);
}

.input[data-disabled]:hover,
.input:disabled:hover {
	border: solid 1px var(--border-primary);
}

.input.readOnly,
.input[data-readonly] {
	cursor: auto;
	color: var(--content-primary);
}

.input.readOnly:hover,
.input[data-readonly]:hover {
	border: solid 1px var(--border-primary);
}

.errorMessage {
	color: var(--content-error);
}

.description {
	color: var(--content-tertiary);
}

.placeholderColor {
	color: var(--content-tertiary);
}
